<app-navbar></app-navbar>
<app-toasts></app-toasts>
<app-alerts></app-alerts>
<router-outlet></router-outlet>
<app-footer></app-footer>
<app-cookie-banner></app-cookie-banner>
